import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageGroup = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('manageGroup', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['groups'] });
      await revalidate(['searchGroups', 'all']);
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};
